export enum ProductClassificationEnum {
  SOFT_SURFACE = 'SoftSurface',
  HARD_SURFACE = 'HardSurface',
  ACCESSORIES = 'Accessories'
}
